import { LeftOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space } from "antd";
import type { CSSProperties, ReactNode } from "react";

export const STICKY_FORM_ACTIONS_STYLE: CSSProperties = {
  position: "sticky",
  top: 0,
  zIndex: 100,
  background: "#fff",
  padding: "12px 0",
  marginBottom: 16,
  borderBottom: "1px solid #f0f0f0",
};

type StickyFormActionsProps = {
  onBack?: () => void;
  backLabel?: ReactNode;
  actions?: ReactNode;
};

export default function StickyFormActions({
  onBack,
  backLabel,
  actions,
}: StickyFormActionsProps) {
  return (
    <div style={STICKY_FORM_ACTIONS_STYLE}>
      <Row justify="space-between" align="middle" wrap={false}>
        <Col flex="none">
          {onBack ? (
            <Button
              type="ghost"
              shape={backLabel ? undefined : "circle"}
              onClick={onBack}
              icon={<LeftOutlined />}
            >
              {backLabel}
            </Button>
          ) : null}
        </Col>
        {actions ? (
          <Col flex="none">
            <Space size={8} wrap>
              {actions}
            </Space>
          </Col>
        ) : null}
      </Row>
    </div>
  );
}
